import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import Logger from '../lib/Logger';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { Tracker } from '../store/tracking/action-creators';
const LOG = Logger.getLogger('redirectToUrl');
export const redirectToUrl = (url, shouldRedirectWindow = true) => (dispatch, getState) => {
  if (!url || typeof url === 'string' && url.trim() === '') {
    LOG.error('Redirecting to a null or empty url');
    return;
  }
  let finalUrl = url;
  const state = getState();
  const isAssignedToACQ176VariantA = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0176, [ExperimentParameterGroup.Variant_A]);
  if (isAssignedToACQ176VariantA) {
    const targetUrl = new URL(url, window.location.href);
    targetUrl.searchParams.set('__initialHubspotTheme', 'trellis-light');
    targetUrl.searchParams.set('resetNavConfig', 'true');
    finalUrl = targetUrl.toString();
  }
  dispatch(Tracker.redirect({
    url: finalUrl
  }));
  if (shouldRedirectWindow) {
    window.location.replace(finalUrl);
  }
};